import { Service } from "../interfaces/service.js";
function composeResponse(data, status) {
  return {
    data,
    status,
    statusText: `${status}`,
    headers: {},
    config: {}
  };
}
function getStorage(storageType) {
  try {
    return window[storageType];
  } catch {
    const storage = {
      data: {},
      setItem: function(key, value) {
        this.data[key] = value;
      },
      getItem: function(key) {
        return this.data[key] ?? null;
      },
      removeItem: function(key) {
        delete this.data[key];
      },
      clear: function() {
        this.data = {};
      },
      length: 0,
      key: function(i) {
        const keys = Object.keys(this.data);
        return keys[i] || null;
      }
    };
    return storage;
  }
}
class StorageAdapter extends Service {
  constructor(storageType, daysToExpire = 0) {
    super();
    this.storageType = storageType;
    this.daysToExpire = daysToExpire;
    this.storage = getStorage(this.storageType);
  }
  storage;
  delete(path) {
    this.storage.removeItem(path);
    return Promise.resolve(composeResponse(void 0, 200));
  }
  get(path) {
    try {
      const element = this.storage.getItem(path);
      if (element) {
        const response = JSON.parse(element);
        if (!StorageAdapter.hasExpired(response)) {
          return Promise.resolve(composeResponse(response.data, 200));
        } else {
          this.storage.removeItem(path);
          return Promise.reject(new Error("Element has expired"));
        }
      }
      return Promise.reject(new Error("Element not found"));
    } catch (e) {
      return Promise.reject(e);
    }
  }
  patch(path, data) {
    return this.post(path, data);
  }
  patchForm(path, data) {
    return this.post(path, data);
  }
  post(path, data) {
    this.storage.setItem(
      path,
      JSON.stringify({
        data,
        createdAt: Date.now().toString(),
        daysToExpire: this.daysToExpire
      })
    );
    return Promise.resolve(composeResponse(data, 200));
  }
  postForm(path, data) {
    return this.post(path, data);
  }
  put(path, data) {
    return this.post(path, data);
  }
  putForm(path, data) {
    return this.post(path, data);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static hasExpired(data) {
    const { createdAt = Date.now(), daysToExpire } = data;
    return !!daysToExpire && (new Date(createdAt).getTime() - Date.now()) / (1e3 * 3600 * 24) > daysToExpire;
  }
  clear() {
    this.storage.clear();
  }
  setInterceptorRequestHeaders(_onFulfilled, _onRejected) {
    throw new Error("Method not implemented.");
  }
  setInterceptorResponseHeaders(_onFulfilled, _onRejected) {
    throw new Error("Method not implemented.");
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeInterceptorRequest(_id) {
    throw new Error("Method not implemented.");
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeInterceptorResponse(_id) {
    throw new Error("Method not implemented.");
  }
  generateCancelRef() {
    return void 0;
  }
}
export {
  StorageAdapter
};
//# sourceMappingURL=storage.adapter.js.map
